import styled from 'styled-components';

import TeachingLearningSequenceInlineSvg from 'approot/shared/inline-svg/teaching-learning-sequence/teaching-learning-sequence-inline-svg';
import {
  gold6,
  grey1,
  grey10,
  grey5,
} from 'approot/shared/styles/colours.style';

export type ActivitySettingsCheckpointProps = {
  $isActive?: boolean;
};

export const ActivitySettingsCheckpoint = styled(
  TeachingLearningSequenceInlineSvg
)<ActivitySettingsCheckpointProps>`
  path {
    stroke: ${({ $isActive }) => ($isActive ? grey5 : grey10)};
    fill: ${({ $isActive }) => ($isActive ? gold6 : grey1)};
  }
`;
